import {ServiceId} from 'shared/models/RouterParam';

export enum LocalStorageKey {
  LAST_CAMPAIGN_ID = 'last_campaign_id',
  LAST_FIELD_ID = 'last_field_id',
  LAST_SERVICE_ID = 'last_service_id',
}

export class LocalStorageModel {
  [LocalStorageKey.LAST_CAMPAIGN_ID]: number | null;
  [LocalStorageKey.LAST_FIELD_ID]: number | null;
  [LocalStorageKey.LAST_SERVICE_ID]: ServiceId | null;
}
